<template>
  <div class="">
    <div class="demo-image__preview">
      <el-image
        v-for="(img, index) in imgList"
        :key="index"
        :src="img"
        :preview-src-list="imgList"
        style="width: 80px; height: 80px; margin: 0 4px"
      >
      </el-image>
      <img
        :src="videoImg"
        v-for="(video, index) in videoList"
        :key="index + 6"
        class="video-show"
        @click="showVideo(video)"
      />
    </div>
    <div
      class="custom-dialog"
      v-if="dialogVisible"
      @click.stop="dialogVisible = false"
    >
      <div class="mask" @click.stop="dialogVisible = false"></div>
      <div class="">
        <div class="video-content" @click.stop>
          <div class="custom-dialog-title" @click.stop>
            <img
              @click.stop="dialogVisible = false"
              src="../../../assets/images/del_icon.png"
            />
          </div>
          <div class="video-space">
            <video
              v-if="currentVideo"
              :src="currentVideo"
              controls
              autoplay
              class="video-fullscreen"
            ></video>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "imgPreview",
  props: {
    attachmentList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  watch: {
    attachmentList: {
      handler(newVal) {
        console.log("attachmentList changed:222", newVal);
      },
      // deep: true,
    },
  },
  data() {
    return {
      url: "",
      imgList: [],
      videoList: [],
      currentVideo: "",
      videoImg: require("@/assets/images/video5.png"),
      dialogVisible: false,
    };
  },
  mounted() {
    console.log("attachmentList==++", this.attachmentList);
    // this.imgList = this.attachmentList;
    this.videoList = [];
    this.imgList = [];
    for (const i of this.attachmentList) {
      if (/\.(mp4)(\?|#|$)/i.test(i)) {
        this.videoList.push(i);
      } else {
        this.imgList.push(i);
      }
    }
  },
  methods: {
    showVideo(url) {
      this.currentVideo = url;
      this.dialogVisible = true;
    },
  },
};
</script>

<style lang="less" scoped>
// ::v-deep .el-image-viewer__close {
//   background-color: red !important;
// }
.video-show {
  width: 80px;
  height: 80px;
  margin: 0 4px;
}

// ::v-deep .el-dialog__wrapper .custom-dialog {
//   width: 100%;
//   display: flex !important;
//   justify-content: center;
//   align-items: center;
//   flex-direction: column;
// }
::v-deep .el-dialog__wrapper {
  display: flex;
  // height: 80%;
  width: 100%;
}
::v-deep .el-dialog__body {
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: auto;
}
.custom-dialog {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0); /* 半透明背景遮罩 */
  z-index: 2008; /* 让遮罩层位于其他内容之上 */
}

.mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5); /* 遮罩背景色 */
  z-index: 2046; /* 避免遮住内容 */
}

.video-content {
  position: relative;
  background-color: #fff;
  padding: 10px;
  // border-radius: 8px;
  // max-width: 50vw;
  // max-height: 50vh;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  z-index: 2057;
}
.custom-dialog-title {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin-bottom: 6px;
  img {
    width: 22px;
    cursor: pointer;
  }
}
.video-space {
  display: flex;
  // width: 50%;
  overflow: auto;
  justify-content: center;
  height: 100%;
}
.video-fullscreen {
  width: 45%;
  // height: 100%;
  height: 100%;
  object-fit: contain; /* 保持视频宽高比 */
}
</style>